import './gb-sayt-categories.tag.html';
import './gb-sayt-search-terms.tag.html';
import './gb-sayt-refinements.tag.html';
import './gb-sayt-divider.tag.html';
riot.tag2('gb-sayt-autocomplete', '<yield> <gb-sayt-categories></gb-sayt-categories> <gb-sayt-divider></gb-sayt-divider> <gb-sayt-search-terms></gb-sayt-search-terms> <gb-sayt-divider></gb-sayt-divider> <gb-sayt-refinements each="{navigations}"></gb-sayt-refinements> </yield>', '.gb-stylish gb-sayt-autocomplete,.gb-stylish [riot-tag="gb-sayt-autocomplete"],.gb-stylish [data-is="gb-sayt-autocomplete"]{ min-width: 210px; }', '', function(opts) {
});



/** WEBPACK FOOTER **
 ** ./src/tags/sayt/gb-sayt-autocomplete.tag.html
 **/